import React from "react";
import { Link } from "react-router-dom";
import { services } from "../data/services";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 pt-14 pb-8" style={{ background: "#050d1c" }}>
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 no-underline mb-4">
              <img src="/images/logo.jpg" alt="EmirATech" className="w-11 h-11 rounded-lg object-cover" />
              <div className="flex flex-col leading-tight">
                <span className="text-white font-semibold text-[15px]" style={{ fontFamily: "Sora, sans-serif" }}>
                  EmirATech
                </span>
                <span className="text-[10px] uppercase tracking-[0.18em] text-[#7fa5e6]">
                  Distribution L.L.C-FZ
                </span>
              </div>
            </Link>
            <p className="text-[#c8d4ea] text-[14px] leading-relaxed max-w-md mb-4" style={{ fontFamily: "Sora, sans-serif" }}>
              Bridging Technologies. Elevating Skies.
            </p>
            <div className="text-[#6b7896] text-[13px] space-y-1">
              <div>Dubai, United Arab Emirates</div>
              <a href="mailto:hello@emiratechdis.com" className="block text-[#c8d4ea] hover:text-white">hello@emiratechdis.com</a>
              <a href="tel:+971585927936" className="block text-[#c8d4ea] hover:text-white">+971 58 592 7936</a>
            </div>
          </div>

          <div>
            <div className="text-white text-[13px] font-semibold uppercase tracking-wider mb-4" style={{ fontFamily: "Sora, sans-serif" }}>
              Services
            </div>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-[#a6b3c8] text-[13.5px] hover:text-white no-underline transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-white text-[13px] font-semibold uppercase tracking-wider mb-4" style={{ fontFamily: "Sora, sans-serif" }}>
              Company
            </div>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-[#a6b3c8] text-[13.5px] hover:text-white no-underline">Home</Link></li>
              <li><Link to="/about" className="text-[#a6b3c8] text-[13.5px] hover:text-white no-underline">About</Link></li>
              <li><Link to="/services" className="text-[#a6b3c8] text-[13.5px] hover:text-white no-underline">All Services</Link></li>
              <li><Link to="/contact" className="text-[#a6b3c8] text-[13.5px] hover:text-white no-underline">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-[#6b7896] text-[12.5px]">
          <div>© {new Date().getFullYear()} EmirATech Distribution L.L.C-FZ. All rights reserved.</div>
          <div>Bridging Technologies. Elevating Skies.</div>
        </div>
      </div>
    </footer>
  );
}
